<template>
	<div class="container">
	<div class="common-header-wrap">
		<mt-header :title="this.$t('menu.my_wallet')" class="common-header">
		<mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
		</mt-header>
	</div>
	<div class="account_header">
		<div class="flex-wrapper">
		<div class="item" style="color: black">{{ $t('wallet.balance') }}</div>
		<!-- <div class="item" style="color: black"><span class="freeze_predeposit">{{ $t('wallet.freeze') }}：{{ utils.currencyPrice(freeze_predeposit) }}</span></div> -->
		</div>
		<div class="predeposit ">
		<span class="available_predeposit" @click="$router.push({ name: 'MemberPredepositList' })">{{ $t('general.dollar_sign') }} {{ utils.currencyPrice(available_predeposit) }}</span>
		</div>
		<div class="card">
		<div class="card_item" style="color: black" @click="$router.push({ name: 'MemberVoucherList', query: { index: 1 } })">{{ $t('wallet.coupon') }} {{ voucher_count}}</div>
		<div class="card_item" style="color: black" @click="$router.push({name:'MemberPointList'})">{{ $t('wallet.point') }} {{ utils.currencyPrice(points) }}</div>
		</div>
	</div>
	<div class="account">
		<div class="menu">
		<div @click="$router.push({name:'MemberPointsOrderList'})"><flex-line class="menu-item" :is-link="true" ><span class="line-name">{{ $t('wallet.exchange_point') }}</span></flex-line></div>
		<!-- <div @click="$router.push({name:'MemberBankList'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">提现账户</span></flex-line></div> -->
		<!-- <div @click="$router.push({name:'MemberRechargeCardList'})"><flex-line class="menu-item" :is-link="true" ><span class="line-name">{{ $t('wallet.my_stored_value_card') }}</span></flex-line></div> -->
		<div @click="$router.push({name:'MemberBonusreceive'})"><flex-line class="menu-item" :is-link="true"><span class="line-name">{{ $t('wallet.lucky_money_record') }}</span></flex-line></div>
		</div>
	</div>
	</div>
</template>

<script>
import { Toast } from 'mint-ui'
import { getMemberIndex } from '../../../api/member'
import { mapState } from 'vuex'
import flexLine from '../../flexLine'
export default {
	components: {
		flexLine
	},
	data () {
		return {
			available_predeposit:0.00,
			freeze_predeposit:0.00,
			voucher_count:0,
			points:0,
			available_rc_balance:0,
		}
	},
	created () {
		getMemberIndex().then(
			response => {
				if (response && response.result.member_info) {
				this.available_predeposit =response.result.member_info.available_predeposit;
				this.freeze_predeposit = response.result.member_info.freeze_predeposit;
				this.voucher_count = response.result.member_info.voucher_count;
				this.points = response.result.member_info.member_points;
				this.available_rc_balance = response.result.member_info.available_rc_balance
				}
			},
			error => {}
		)
	},
	computed: {

	},
	mounted () {

	},
	methods: {

	}
}
</script>
<style scoped lang="scss">
	.common-header-wrap .common-header {
		box-shadow: unset;
	}
	.account_header {
		background-color: #f4c41e;
		color: #fff;
		padding: 3rem 0.7rem .7rem;
		font-size:$fontSize;
		box-sizing: border-box;
		margin-top: -2rem;
		.flex-wrapper {
			display: flex;
			.item {
				flex:1;
				font-size:$subFontSize
			}
			.freeze_predeposit {
				float: right;
				padding: .1rem .5rem;
				border: 1px solid black;
				border-radius: .5rem;
				font-size:$h6;
			}
		}
		.predeposit{
			padding: .5rem 0;
			margin-top:.5rem;
			text-align: center;
			.available_predeposit {
				font-size:1.6rem;
			}
		}
		.card{
			margin-top: .8rem;
			padding-top:.5rem;
			border-top:1px solid black;
			overflow: hidden;
			.card_item {
				float: left;
				width: 50%;
			}
			.card_item:nth-child(2) {
				text-align: right;
			}
		}
	}
	.predeposit_handle {
		background-color: #fff;
		padding: .5rem 0;
		text-align: center;
		overflow: hidden;
		font-size:$subFontSize;
		display: flex;
		position: relative;
		box-shadow: 0px 4px 4px #f7f7f7;
		z-index: 2;
		.item {
			flex:1;
			position: relative;
			height: 2rem;
			display: flex;
			align-items: center;
			justify-content: center;
			&:first-child::after {
				content:'';
				position: absolute;
				top:0;
				bottom:0;
				right:0;
				border-right: 1px dashed #eee;
			}
			.img {
				margin: 0 .5rem ;
				height: 1.2rem;
			}
		}
	}
	.account {
		// padding: 0 $pageSpace;
		background: #fff;
		.menu {
			background: #f5f5f5;
		}
	}
	.menu-item {
		padding: 0 $pageSpace;
   	 	margin: 10px 0px 0px;
	}
	.flex-line {
		.arrow {
			color: black;
			font-weight: bold;
			font-size: 1rem;
		}
	}
</style>
